import { render } from "./ShroffIncomeSecretary.vue?vue&type=template&id=a55417aa"
import script from "./ShroffIncomeSecretary.vue?vue&type=script&lang=js"
export * from "./ShroffIncomeSecretary.vue?vue&type=script&lang=js"

import "./ShroffIncomeSecretary.vue?vue&type=style&index=0&id=a55417aa&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__